var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.opened
    ? _c(
        "v-dialog",
        {
          attrs: {
            scrollable: "",
            value: _vm.opened,
            transition: false,
            persistent: false,
          },
          on: {
            "click:outside": function ($event) {
              _vm.opened = false
            },
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "overflow-y-hidden",
              attrs: { "min-height": "820px" },
            },
            [
              _c("v-card-title", { staticClass: "headline" }),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: { "fixed-tabs": "" },
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c("v-tab", [_vm._v("Загрузить")]),
                      !_vm.payloadOnly
                        ? _c("v-tab", [_vm._v("Выбрать из медиа-библиотеки")])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-tabs-items",
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c("MediaFileLoader", {
                                    attrs: {
                                      "file-type": _vm.fileType,
                                      multiple: _vm.multiple,
                                      "return-file-only": _vm.returnFileOnly,
                                    },
                                    on: {
                                      "files-uploaded": _vm.uploadFiles,
                                      "close-dialog": _vm.close,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tab-item",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _vm.opened
                                    ? _c("MediaLibraryFilePicker", {
                                        ref: "library",
                                        attrs: {
                                          "file-type": _vm.fileType,
                                          value: _vm.value,
                                        },
                                        on: { change: _vm.uploadFiles },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _vm._t("actions", function () {
                    return [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary darken-2" },
                          on: { click: _vm.close },
                        },
                        [_vm._v(" Закрыть ")]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }